import { useEffect } from "react";

const PRIVACY_POLICY_SRC = `${process.env.PUBLIC_URL || ""}/privacypolicy.html`;

function PrivacyPolicy() {
  useEffect(() => {
    document.body.classList.remove("overflow-hidden");
  }, []);

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <iframe
        title="Privacy Policy"
        src={PRIVACY_POLICY_SRC}
        style={{ border: "none", width: "100%", minHeight: "100vh" }}
        loading="lazy"
      />
    </div>
  );
}

export default PrivacyPolicy;
